export default [
  {
    "score": 20,
    "title": "Doctor 1 - 2 Weeks",
    "text": "You should see your doctor in 1-2 weeks… or talk to your doctor sometime in the next week.",
    "description": "A primary care physician (PCP) treats a wide range of diseases and conditions. You should see or talk to your primary physician first for most health problems that are not emergencies. Your PCP may send you to a specialist doctor if your health problem needs special care or an expert opinion.",
    "timing": "You will need to call the office and get an appointment. Office hours are usually Monday through Friday between 8 AM and 5 PM. However, every office has their own schedule. Some offices have appointment times on evenings and weekends.",
    "locationCode": "PCP",
    "services": [
      {
        "textToShow": null,
        "text": "Telemedicine",
        "points": 0,
        "order": 1,
        "direction": "Good",
        "rating": 0
      },
      {
        "textToShow": null,
        "text": "Clinic",
        "points": 0,
        "order": 3,
        "direction": "Good",
        "rating": 0
      },
      {
        "textToShow": null,
        "text": "Urgent Care",
        "points": 0,
        "order": 5,
        "direction": "Good",
        "rating": 0
      },
      {
        "textToShow": null,
        "text": "Emergency Room",
        "points": 0,
        "order": 6,
        "direction": "Other",
        "rating": 0
      },
      {
        "textToShow": null,
        "text": "Medical Facility",
        "points": 0,
        "order": 5,
        "direction": "Top",
        "rating": 0
      },
    ],
    "callDoctorTitle": "Call Doctor This Week",
    "locationCost": 2,
    "primaryCCC": 3606
  }
]


// [
//   {
//     score: 85,
//     title: 'Emergency Department (ER)',
//     text: 'Go to a nearby emergency department (ER) right now.',
//     description: 'This is the department in a hospital that provides ' +
//     'care right away when you are very sick or badly ' +
//     'injured. The emergency room has people and ' +
//     'equipment to take care of severe, high risk, and ' +
//     'life-threatening problems. No appointment is ' +
//     'needed, but remember that the sickest patients are ' +
//     'seen first. The other name for emergency room is ' +
//     'emergency department.',
//     timing: 'If you have an emergency, you should go right ' +
//     'away. The emergency department (ER) is open 24 ' +
//     'hours a day. No appointment is needed. However, ' +
//     'remember that the sickest patients are seen ' +
//     'first.',
//     locationCode: 'ED',
//     services: [
//       {
//         textToShow: null,
//         text: 'Emergency Room',
//         points: 0,
//         order: 1,
//         direction: 'Top',
//         rating: 0
//       }
//     ],

//     callDoctorTitle: 'Call Doctor Now',
//     locationCost: 4,
//     primaryCCC: 128
//   }
// ]
